
<template>
<v-app>
  <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>

 <v-row  justify="center">
   <v-col  cols="12" lg="12" md="12" sm="12">
   <v-card color="#393E46">
     <v-card-title>
       Stocks
     </v-card-title>
     <v-card-text>
<v-row>
  <v-col cols="4">
  <h1>Lima</h1><br/>
    <p v-for="ite in lima" :key="ite.id">
      {{ite.premio}} : {{ite.stock}}
    </p>
  </v-col>
  <v-col cols="4">
    <h1>Chiclayo</h1><br/>
    <p v-for="ite in chiclayo" :key="ite.id">
      {{ite.premio}} : {{ite.stock}}
    </p>
  </v-col>
  <v-col cols="4">
    <h1>Arequipa</h1><br/>
    <p v-for="ite in aqp" :key="ite.id">
      {{ite.premio}} : {{ite.stock}}
    </p>
  </v-col>

</v-row>

   </v-card-text>
   </v-card></v-col>
 </v-row>





  </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>
import axios from 'axios';
import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import Cabecerabaja from "@/components/general/cabecerabaja";

  export default {
    name: 'acto',
    components: {
      Cabecerabaja,
    cabecera,
    piepagina,
  },
    data () {
      return {
        lima: [],
        chiclayo: [],
        aqp: [],

      }
    },
    mounted(){
this.damestocks();
    },


    methods: {


      damestocks(){

          axios
              .get('juegos/stocks/mall-28-julio-lima')
              .then(response => {
                this.lima = response.data.filter(item => item.esPremio === true)
              })
              .catch((error) => {
                console.log(error);
              });
        axios
            .get('juegos/stocks/mall-28-chiclayo')
            .then(response => {
              this.chiclayo = response.data.filter(item => item.esPremio === true)
            })
            .catch((error) => {
              console.log(error);
            });
        axios
            .get('juegos/stocks/mall-28-arequipa')
            .then(response => {
              this.aqp = response.data.filter(item => item.esPremio === true)
            })
            .catch((error) => {
              console.log(error);
            });
      },

    },
computed: {
  // map `this.user` to `this.$store.getters.user`

}
  }
</script>
